import { useQuery } from '@tanstack/react-query';
import { OilSupplierService } from 'services/openapi';
import { OilSupplierQueryKeys } from './constants';

export const useGetAllOilSuppliersQuery = () => {
  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery({
    queryKey: [OilSupplierQueryKeys.GET_OIL_SUPPLIERS],
    queryFn: () => OilSupplierService.oilSupplierControllerGetAllSimple(),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    error,
    data: data?.data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  };
};
